<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import IconLucide from '@/components/icons/IconLucide.vue'
import echo from '@/echo'
import Cash from '@/assets/sound/notif.wav'
import { useAuthStore, useSavingStore, useUtilsStore } from '@/stores'

export default defineComponent({
  name: 'NavNotifikasi',
  components: { IconLucide },
  setup() {
    const useUtils = useUtilsStore()
    const useAuth = useAuthStore()
    const useSaving = useSavingStore()
    const audio = new Audio(Cash)

    const clickToast = (message: string, status: string) => {
      useUtils.toggleAlert(message, status)
    }

    onMounted(() => {
      useAuth.userLogin().then((res) => {
        echo
          .private(`user.${res.user_id}`)
          .listen('.saving-notification', (e: { message: string; status: string }) => {
            useSaving.getSaving()
            useSaving.getInvoice()
            clickToast(e.message, e.status)
            audio.play()
          })
      })
    })

    return {}
  },
})
</script>

<template>
  <div class="flex-none">
    <div class="dropdown dropdown-end">
      <div tabindex="0" role="button" class="indicator">
        <span class="indicator-item badge badge-secondary badge-xs"></span>
        <button class="btn m-1 btn-sm btn-circle">
          <IconLucide name="Bell" class="w-6 h-6" />
        </button>
      </div>
      <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-1 w-52 p-2 shadow-sm">
        <li><a>Item 1</a></li>
        <li><a>Item 2</a></li>
      </ul>
    </div>
  </div>
</template>

<style></style>
